
// Minimal configuration for an unauthenticated request
const BASE_REQUEST_CONFIG = {
  mode: 'cors',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
};

// Minimal configuration for an unauthenticated PUT request
const BASE_PUT_CONFIG = {
  ...BASE_REQUEST_CONFIG,
  method: 'PUT'
};

// Minimal configuration for an unauthenticated POST request
const BASE_POST_CONFIG = {
  ...BASE_REQUEST_CONFIG,
  method: 'POST'
};

/**
 * Send a request to create a ForgotPasswordToken
 * The server will send an email with the token to the given
 * email address.
 *
 * @param {string} email - The email address the one-time token should
 *  be sent to
 * @returns A promise for the JSON response
 */
function createForgotPasswordToken(email) {
  return fetch(
    `${process.env.REACT_APP_API_URL}/users/forgot_password`,
    {
      ...BASE_PUT_CONFIG,
      body: JSON.stringify(email)
    }
  ).then(response => response.json());
}

/**
 * Send a request to reset the user's password
 *
 * @param {string} token - The one-time token sent to the user via email
 * @param {string} passwword - The user's new password
 * @returns A promise for the JSON response
 */
function resetForgottenPassword({token, password}) {
  console.log(token);
  return fetch(
    `${process.env.REACT_APP_API_URL}/users/forgot_password`,
    {
      ...BASE_POST_CONFIG,
      body: JSON.stringify({
        token: token.trim(),
        password
      })
    }
  );
}

export { createForgotPasswordToken, resetForgottenPassword }
